module.exports = "/images/img_guide01_sp.png?d30f304302a10828caadd2aabc76509c";